<!-- 我的收藏 -->
<template>
  <div class="tabs">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, key) in tabs"
        :key="key"
        :label="item.label"
        :name="item.name"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="lists" v-loading="loading">
      <div class="flex flex-wrap" v-if="activeName === '1'">
        <Service
          v-for="(item, index) in myCollectList"
          :key="index"
          :good="item"
          :index="index"
        />
      </div>
      <div v-else-if="activeName === '2'">
        <Laboratory
          v-for="(item, index) in myCollectList"
          :key="index"
          :data="item"
          :index="index"
        />
      </div>
    </div>
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="pageParams[activeName]"
      @pageIndexChange="handlePageChange"
    />
  </div>
</template>
<script>
import { collectList } from "@/api/userCenter";
import Service from "./components/Service.vue";
import Laboratory from "./components/Laboratory.vue";
import Pagination from "@/components/Pagination/index";
import { mapGetters } from "vuex";
export default {
  components: {
    Service,
    Pagination,
    Laboratory,
  },
  data() {
    return {
      tabs: [
        { label: "服务", name: "1" },
        { label: "实验室", name: "2" },
      ],
      activeName: "1",
      pageParams: {
        1: {
          pageIndex: 1,
          pageSize: 5,
        },
        2: {
          pageIndex: 1,
          pageSize: 10,
        },
      },
      myCollectList: [],
      loading: false,
      totalItem: 0,
    };
  },
  computed: {
    ...mapGetters(["userBaseInfo"]),
  },
  created() {
    this.getCollectList();
  },
  methods: {
    // tab切换
    handleTabClick() {
      this.pageParams[this.activeName].pageIndex = 1;
      this.totalItem = 0;
      this.myCollectList = [];
      this.getCollectList();
    },
    // 分页
    handlePageChange(page) {
      this.pageParams[this.activeName] = page;
      this.getCollectList();
    },

    // 获取收藏列表
    async getCollectList() {
      this.loading = true;
      const { list, totalItem } = await this.$axios
        .post(collectList, {
          ...this.pageParams[this.activeName],
          collectType: this.activeName,
        })
        .finally(() => {
          this.loading = false;
        });
      this.myCollectList = list;
      this.totalItem = totalItem;
    },
    // 列表项的点击, 跳转到知识园地详情
    knowledgeClick(data) {
      this.$jump.push({
        name: "journalDetail",
        query: { id: data.resourceId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  padding: 0 15px;
}
.lists {
  min-height: 550px;
  &-knowledge {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 20px;
  }
  &-liveWrap {
    display: grid;
    grid-template-columns: repeat(2, 48%);
    gap: 20px 20px;
  }
}
</style>
